<template>
    <teleport to="body">
        <TransitionRoot as="template" :show="show">
            <Dialog
                as="div"
                static
                class="fixed z-10 inset-0 overflow-y-auto"
                @close="show = false"
                :open="show"
            >
                <div
                    class="
                        flex
                        items-end
                        justify-center
                        min-h-screen
                        pt-4
                        px-4
                        pb-20
                        text-center
                        sm:block
                        sm:p-0
                    "
                >
                    <TransitionChild
                        as="template"
                        enter="ease-out duration-300"
                        enter-from="opacity-0"
                        enter-to="opacity-100"
                        leave="ease-in duration-200"
                        leave-from="opacity-100"
                        leave-to="opacity-0"
                    >
                        <DialogOverlay
                            v-if="closable"
                            class="
                                fixed
                                inset-0
                                bg-gray-500 bg-opacity-75
                                transition-opacity
                            "
                        />
                        <div
                            v-else
                            class="
                                fixed
                                inset-0
                                bg-gray-500 bg-opacity-75
                                transition-opacity
                            "
                        ></div>
                    </TransitionChild>

                    <!-- This element is to trick the browser into centering the modal contents. -->
                    <span
                        class="
                            hidden
                            sm:inline-block
                            sm:align-middle
                            sm:h-screen
                        "
                        aria-hidden="true"
                        >&#8203;</span
                    >
                    <TransitionChild
                        as="template"
                        enter="ease-out duration-300"
                        enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enter-to="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leave-from="opacity-100 translate-y-0 sm:scale-100"
                        leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <div
                            class="
                                inline-block
                                align-bottom
                                bg-white
                                rounded-lg
                                text-left
                                overflow-hidden
                                shadow-xl
                                transform
                                transition-all
                                sm:my-8
                                sm:align-middle
                                sm:max-w-xl
                                w-full
                            "
                        >
                            <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                <div class="w-full">
                                    <div
                                        v-if="$slots.header"
                                        class="
                                            mx-auto
                                            flex-shrink-0 flex
                                            items-center
                                            justify-center
                                            h-12
                                            w-12
                                            rounded-full
                                            bg-red-100
                                            sm:mx-0
                                            sm:h-10
                                            sm:w-10
                                        "
                                    >
                                        <slot name="header"></slot>
                                    </div>
                                    <div
                                        v-if="$slots.title"
                                        class="
                                            mt-3
                                            text-center
                                            sm:mt-0
                                            sm:ml-4
                                            sm:text-left
                                        "
                                    >
                                        <DialogTitle
                                            as="h3"
                                            class="
                                                text-lg
                                                leading-6
                                                font-medium
                                                text-gray-900
                                            "
                                        >
                                            <slot name="title"></slot>
                                        </DialogTitle>
                                        <div class="mt-2 w-full">
                                            <slot name="content"></slot>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="$slots.footer"
                                class="
                                    bg-gray-50
                                    px-4
                                    py-3
                                    sm:px-6
                                    sm:flex sm:flex-row-reverse
                                "
                            >
                                <slot name="footer"></slot>
                            </div>
                        </div>
                    </TransitionChild>
                </div>
            </Dialog>
        </TransitionRoot>
    </teleport>
</template>

<script>
import {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
} from "@headlessui/vue";

export default {
    emits: ["close"],
    methods: {
        close() {
            this.$emit("close");
        },
    },
    components: {
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
    },
    props: {
        closable: {
            type: Boolean,
            default: false,
        },
        show: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
